import { Box, Flex, Text } from '@chakra-ui/react';
import * as React from 'react';

import { MessageIncoming } from './message-incoming';
import { MessageOutgoing } from './message-outgoing';

export type PointOfView = 'contact' | 'system';
export type MessageType = 'isIncoming' | 'isOutgoing';

export interface MessageItem {
  id: string;
  type: MessageType;
  message: string | React.ReactNode;
  caption?: string;
}

export interface MessagePrefixProps {
  systemPrefix?: string;
  orgPrefix?: string;
  titlePrefix?: string;
  namePrefix?: string;
  caseIdPrefix?: string;
  phonePrefix?: string;
  separator?: string;
  pointOfView?: PointOfView;
}

interface MessageProps extends MessageItem, MessagePrefixProps {}

interface MessageArrayProps extends MessagePrefixProps {
  messages: MessageItem[];
}

const Message: React.FC<MessageProps> = ({
  id,
  type,
  message,
  systemPrefix,
  orgPrefix,
  titlePrefix,
  namePrefix,
  caseIdPrefix,
  phonePrefix,
  separator,
  pointOfView,
}) => {
  const isOutgoing = type === 'isOutgoing';

  if (isOutgoing) {
    return (
      <MessageOutgoing
        id={id}
        message={message}
        pointOfView={pointOfView}
        systemPrefix={systemPrefix}
        orgPrefix={orgPrefix}
        titlePrefix={titlePrefix}
        namePrefix={namePrefix}
        caseIdPrefix={caseIdPrefix}
        phonePrefix={phonePrefix}
        separator={separator}
      />
    );
  }

  return (
    <MessageIncoming id={id} message={message} pointOfView={pointOfView} />
  );
};

const MessagePreviewItem: React.FC<MessageArrayProps> = ({
  systemPrefix,
  orgPrefix,
  titlePrefix,
  namePrefix,
  caseIdPrefix,
  phonePrefix,
  separator = ' | ',
  messages,
  pointOfView = 'contact',
}) => (
  <Flex
    bg="bg.surface.lv2"
    borderRadius="md"
    flexDirection="column"
    w="full"
    h="full"
    p={3}
  >
    {messages.map((msg) => (
      <Box key={msg.id}>
        <Message
          id={msg.id}
          type={msg.type}
          message={msg.message}
          systemPrefix={systemPrefix}
          orgPrefix={orgPrefix}
          titlePrefix={titlePrefix}
          namePrefix={namePrefix}
          caseIdPrefix={caseIdPrefix}
          phonePrefix={phonePrefix}
          separator={separator}
          pointOfView={pointOfView}
        />
        {msg.caption && (
          <Text fontSize="xs" color="fg.muted" mt={-2} mb={3}>
            {msg.caption}
          </Text>
        )}
      </Box>
    ))}
  </Flex>
);

export default MessagePreviewItem;
